// extracted by mini-css-extract-plugin
export var colorSquare = "_nf-0";
export var danger = "_nf-5";
export var lightPink = "_nf-8";
export var neutralBlue = "_nf-7";
export var neutralYellow = "_nf-6";
export var normal = "_nf-1";
export var primary = "_nf-2";
export var primaryLight = "_nf-3";
export var solidBlack = "_nf-g";
export var solidGreen = "_nf-b";
export var solidLightBlue = "_nf-d";
export var solidNavy = "_nf-c";
export var solidOrange = "_nf-f";
export var solidPink = "_nf-e";
export var solidRed = "_nf-9";
export var solidYellow = "_nf-a";
export var success = "_nf-4";